import { render, staticRenderFns } from "./FormPhieuMuon.vue?vue&type=template&id=38f682f5&scoped=true"
import script from "./FormPhieuMuon.vue?vue&type=script&lang=js"
export * from "./FormPhieuMuon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f682f5",
  null
  
)

export default component.exports